import { Component, OnInit } from '@angular/core';
import { UserModel } from 'src/app/models/user.model';
import { UserService } from 'src/app/services/user.service';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { UnAuthorizedMessage, LanguageConstants} from '../../shared-components/constant';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unauthorize',
  templateUrl: './unauthorize.component.html',
  styleUrls: ['./unauthorize.component.css']
})
export class UnauthorizeComponent implements OnInit {
  user: UserModel;
  message: string;
  public isclosedproject = false;
  currLangTranslation: any;
  langCode: string;  
  constructor(private userService: UserService, private location: Location, private activatedRoute: ActivatedRoute, private translateService: TranslateService) { }

  ngOnInit() {
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.currLangTranslation = langEvent.translations;
      if (this.activatedRoute.snapshot.queryParams.redirectFrom === 'analytics-report') {
        this.message = this.currLangTranslation.projectManagement.messages.analyticsReport;
      } else if (this.activatedRoute.snapshot.queryParams.redirectFrom === 'engagement') {
        this.message = this.currLangTranslation.projectManagement.messages.engagement;
      }
      else if (this.activatedRoute.snapshot.queryParams.redirectFrom === 'closedproject') {
        this.message = this.currLangTranslation.projectManagement.messages.closedProject;
        this.isclosedproject = true;
      }
      else {
        this.message = this.currLangTranslation.projectManagement.messages.common;
      }
    });
    // this.getUserPrivacyPolicy();
    if (this.activatedRoute.snapshot.queryParams.redirectFrom === 'analytics-report') {
      this.message = this.currLangTranslation.projectManagement.messages.analyticsReport;
    } else if (this.activatedRoute.snapshot.queryParams.redirectFrom === 'engagement') {
      this.message = this.currLangTranslation.projectManagement.messages.engagement;
    }
    else if (this.activatedRoute.snapshot.queryParams.redirectFrom === 'closedproject') {
      this.message = this.currLangTranslation.projectManagement.messages.closedProject;
      this.isclosedproject = true;
    }
    else {
      this.message = this.currLangTranslation.projectManagement.messages.common;
    }
  }

  getUserPrivacyPolicy() {
    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData !== undefined) {
        this.user = userData;
      }
    });
  }

  savePrivacyPolicy() {
    this.userService.updateUserPrivacyPolicyFlag(this.user).subscribe(resp => {
      location.reload();
    });
  }

}
